// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { AmuletRules } from '@daml.js/splice-amulet/lib/Splice/AmuletRules';
import { useExerciseSubmission } from './ledger/useSubmission';

const useTapCoin = () => {
  const { submit } = useExerciseSubmission(
    AmuletRules.AmuletRules_DevNet_Tap,
    'Successfully tapped coin.',
    'Failed to tap coin.',
  );

  return submit;
};

export default useTapCoin;
